import { Group } from '@mantine/core';

import classes from './default-pending-component.module.css';

export function DefaultPendingComponent() {
  return <Group className={classes.container} h="100vh"></Group>;
}

export default DefaultPendingComponent;
